import Header from '@/components/organisms/Header'

interface MobileLayoutProps {
  children: React.ReactNode
}

const MobileLayout = ({ children }: MobileLayoutProps) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f2f1f6] to-[#eae9ec] dark:from-[var(--header-bg)] dark:to-[var(--header-bg)] relative">
      {/* Header */}
      <Header />

      {/* Main Content */}
      <main className="min-h-screen relative">
        {children}
      </main>
    </div>
  )
}

export default MobileLayout 